
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

import API_URL from "../config/config";
import "../css/categories.css";

function Categories() {
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        loadCategories();
    }, []);

    const loadCategories = () => {
        axios
            .get(`${API_URL}/categories`)
            .then((res) => {
                console.log("Categories API:", res.data);

                const data = Array.isArray(res.data)
                    ? res.data
                    : res.data.categories || res.data.data || [];

                const activeCategories = data.filter(
                    (item) => item.status === "Active"
                );

                setCategories(activeCategories);
            })
            .catch((err) => {
                console.log("Categories Error:", err);
                setCategories([]);
            });
    };

    return (
        <section className="categories-section">
            <h2>Shop By Category</h2>

            <div className="category-grid">
                {categories.length > 0 ? (
                    categories.map((item) => (
                        <Link
                            key={item.id}
                            to={`/shop?category=${item.name}`}
                            className="category-link"
                        >
                            <div className="category-card">
                                <div className="emoji">
                                    {item.emoji}
                                </div>

                                <h3>{item.name}</h3>
                            </div>
                        </Link>
                    ))
                ) : (
                    <p>No Categories Found</p>
                )}
            </div>
        </section>
    );
}

export default Categories;
